<div class="agm-core-search">
  <mat-form-field whFlex appearance="outline" [floatLabel]="'always'">
    <mat-label>{{ "location.ui.filterheader.label" | translate }}</mat-label>
    <mat-icon matPrefix color="accent">search</mat-icon>
    <input
      data-cy="search-location"
      matInput
      #search
      type="search"
      name="location-search"
      [placeholder]="'location.ui.filterheader.placeholder' | translate"
      autocomplete="off"
      data-lpignore="true"
      data-1p-ignore="true"
      data-bwignore="true"
      data-form-type="other"
      [tabIndex]="tabIndex()"
      [matAutocomplete]="locationAuto"
      (input)="onSearchInput(search.value)"
    />
    <mat-autocomplete
      #locationAuto="matAutocomplete"
      [displayWith]="displayPrediction"
      (optionSelected)="onPredictionSelected($event.option.value)"
    >
      @for (suggestion of predictions; track $index) {
        <mat-option [value]="suggestion">
          {{ suggestion.placePrediction?.text?.text }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>
